import { render, staticRenderFns } from "./ControlsPreset.vue?vue&type=template&id=555d4868&scoped=true"
import script from "./ControlsPreset.vue?vue&type=script&lang=js"
export * from "./ControlsPreset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555d4868",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('555d4868')) {
      api.createRecord('555d4868', component.options)
    } else {
      api.reload('555d4868', component.options)
    }
    module.hot.accept("./ControlsPreset.vue?vue&type=template&id=555d4868&scoped=true", function () {
      api.rerender('555d4868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/control/components/ControlsPreset.vue"
export default component.exports